import React, {memo} from 'react';
import DetailedTicketInformationView from './view';

function DetailedTicketInformation(props) {	
	return (
		<>
			<DetailedTicketInformationView 
				{...props}
				/>
		</>
	);
}

export default memo(DetailedTicketInformation);
